// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media (max-width: 1024px) {
  .col-sm-1 {
    width: 8.33%;
  }
  .col-sm-2 {
    width: 16.66%;
  }
  .col-sm-3 {
    width: 25%;
  }
  .col-sm-4 {
    width: 33.33%;
  }
  .col-sm-5 {
    width: 41.66%;
  }
  .col-sm-6 {
    width: 50%;
  }
  .col-sm-7 {
    width: 58.33%;
  }
  .col-sm-8 {
    width: 66.66%;
  }
  .col-sm-9 {
    width: 75%;
  }
  .col-sm-10 {
    width: 83.33%;
  }
  .col-sm-11 {
    width: 91.66%;
  }
  .col-sm-12 {
    width: 100%;
  }
  .col-sm-offset-1 {
    margin-left: 8.33%;
  }
  .col-sm-offset-2 {
    margin-left: 16.66%;
  }
  .col-sm-offset-3 {
    margin-left: 25%;
  }
  .col-sm-offset-4 {
    margin-left: 33.33%;
  }
  .col-sm-offset-5 {
    margin-left: 41.66%;
  }
  .col-sm-offset-6 {
    margin-left: 50%;
  }
  .col-sm-offset-7 {
    margin-left: 58.33%;
  }
  .col-sm-offset-8 {
    margin-left: 66.66%;
  }
  .col-sm-offset-9 {
    margin-left: 75%;
  }
  .col-sm-offset-10 {
    margin-left: 83.33%;
  }
  .col-sm-offset-11 {
    margin-left: 91.66%;
  }
  .col-sm-offset-12 {
    margin-left: 100%;
  }
}
@media (min-width: 1025px) {
  .col-md-1 {
    width: 8.33%;
  }
  .col-md-2 {
    width: 16.66%;
  }
  .col-md-3 {
    width: 25%;
  }
  .col-md-4 {
    width: 33.33%;
  }
  .col-md-5 {
    width: 41.66%;
  }
  .col-md-6 {
    width: 50%;
  }
  .col-md-7 {
    width: 58.33%;
  }
  .col-md-8 {
    width: 66.66%;
  }
  .col-md-9 {
    width: 75%;
  }
  .col-md-10 {
    width: 83.33%;
  }
  .col-md-11 {
    width: 91.66%;
  }
  .col-md-12 {
    width: 100%;
  }
  .col-md-offset-1 {
    margin-left: 8.33%;
  }
  .col-md-offset-2 {
    margin-left: 16.66%;
  }
  .col-md-offset-3 {
    margin-left: 25%;
  }
  .col-md-offset-4 {
    margin-left: 33.33%;
  }
  .col-md-offset-5 {
    margin-left: 41.66%;
  }
  .col-md-offset-6 {
    margin-left: 50%;
  }
  .col-md-offset-7 {
    margin-left: 58.33%;
  }
  .col-md-offset-8 {
    margin-left: 66.66%;
  }
  .col-md-offset-9 {
    margin-left: 75%;
  }
  .col-md-offset-10 {
    margin-left: 83.33%;
  }
  .col-md-offset-11 {
    margin-left: 91.66%;
  }
  .col-md-offset-12 {
    margin-left: 100%;
  }
}
.reports-tab .margin-10 {
  margin-bottom: 20px;
}
.reports-tab .dropdown-section, .reports-tab .select-dates {
  width: 60%;
}
.reports-tab label {
  margin-right: 3px;
  margin-top: -2px;
  font-family: "Omnes-ATT-W02", Arial;
  font-size: 1.6rem;
}
.reports-tab p {
  font-size: 100%;
  margin-bottom: 20px;
}
.reports-tab .dateRangeHeader {
  font: 1.6rem "Omnes-ATT-W02-medium" !important;
}
.reports-tab .dateRangeLabel {
  margin-bottom: 5px;
}
.reports-tab .device-header {
  margin-top: 20px;
}
.reports-tab .device-header label {
  font: 1.4rem "Omnes-ATT-W02-medium";
}
.reports-tab .cta {
  border-top: 1px solid #d2d2d2;
  padding: 30px 0 60px;
  margin-top: 30px;
}
.reports-tab .box-outer {
  padding: 0 30px;
}
.reports-tab tr th:first-child {
  width: 15%;
}
.reports-tab .reports {
  margin-bottom: 20px;
}
.reports-tab .buttons-section {
  border-top: 1px solid #d2d2d2;
  padding: 30px 0;
}
.reports-tab .buttons-section .btn-cancel {
  margin-right: 30px;
}
.reports-tab .check {
  margin-bottom: 30px;
}
.reports-tab .error-text {
  color: hsl(0, 66%, 49%);
}
.reports-tab .error-text .skin {
  border: 1px solid hsl(0, 66%, 49%);
}
.reports-tab .modal-header {
  margin-bottom: 10px;
}
.reports-tab .reporttabcontainer {
  position: relative;
}
.reports-tab .reporttabcontainer .pagination::after {
  border: 0 none;
  height: 0;
  width: 0;
}
.reports-tab .alert {
  margin-bottom: 30px;
}
@media (max-width: 1024px) {
  .reports-tab {
    margin: 0 15px;
  }
  .reports-tab .margin-10 {
    margin: 10px 0px;
  }
  .reports-tab .btn-cancel {
    margin: 20px 0;
    text-align: center;
    width: 100%;
  }
  .reports-tab .btn {
    text-align: center;
    width: 100%;
  }
  .reports-tab .buttons-section {
    padding: 20px 0 0;
  }
  .reports-tab .buttons-section .btn-cancel {
    margin: 20px 0 30px;
  }
  .reports-tab .cta {
    padding: 20px 0 30px;
    margin: 0 1px;
  }
  .reports-tab .cta a {
    text-align: center;
  }
  .reports-tab .cta button {
    margin: 0 0 0 20px;
    text-align: center;
  }
  .reports-tab .tab-nav app-tab .list > a {
    padding: 25px 1px !important;
  }
  .reports-tab .reports,
  .reports-tab .check {
    margin-bottom: 20px;
  }
  .reports-tab .form-group {
    margin-bottom: 20px;
  }
  .reports-tab .step-indicator,
  .reports-tab .alert {
    margin-bottom: 30px !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/lib/ng2-sapmp/src/assets/style/mixinfunction.scss","webpack://./src/lib/ng2-sapmp/src/assets/style/variables.scss","webpack://./src/app/pages/report/transaction/date-range/date-range.component.scss"],"names":[],"mappings":"AAwBI;EA4BA;IACE,YClDE;ECAN;EFiDE;IACE,aClDE;ECGN;EF8CE;IACE,UClDE;ECMN;EF2CE;IACE,aClDE;ECSN;EFwCE;IACE,aClDE;ECYN;EFqCE;IACE,UClDE;ECeN;EFkCE;IACE,aClDE;ECkBN;EF+BE;IACE,aClDE;ECqBN;EF4BE;IACE,UClDE;ECwBN;EFyBE;IACE,aClDE;EC2BN;EFsBE;IACE,aClDE;EC8BN;EFmBE;IACE,WClDE;ECiCN;EFqBE;IACE,kBCvDE;ECoCN;EFkBE;IACE,mBCvDE;ECuCN;EFeE;IACE,gBCvDE;EC0CN;EFYE;IACE,mBCvDE;EC6CN;EFSE;IACE,mBCvDE;ECgDN;EFME;IACE,gBCvDE;ECmDN;EFGE;IACE,mBCvDE;ECsDN;EFAE;IACE,mBCvDE;ECyDN;EFHE;IACE,gBCvDE;EC4DN;EFNE;IACE,mBCvDE;EC+DN;EFTE;IACE,mBCvDE;ECkEN;EFZE;IACE,iBCvDE;ECqEN;AACF;AF7CI;EAoCA;IACE,YC9DE;EC0EN;EFbE;IACE,aC9DE;EC6EN;EFhBE;IACE,UC9DE;ECgFN;EFnBE;IACE,aC9DE;ECmFN;EFtBE;IACE,aC9DE;ECsFN;EFzBE;IACE,UC9DE;ECyFN;EF5BE;IACE,aC9DE;EC4FN;EF/BE;IACE,aC9DE;EC+FN;EFlCE;IACE,UC9DE;ECkGN;EFrCE;IACE,aC9DE;ECqGN;EFxCE;IACE,aC9DE;ECwGN;EF3CE;IACE,WC9DE;EC2GN;EFzCE;IACE,kBCnEE;EC8GN;EF5CE;IACE,mBCnEE;ECiHN;EF/CE;IACE,gBCnEE;ECoHN;EFlDE;IACE,mBCnEE;ECuHN;EFrDE;IACE,mBCnEE;EC0HN;EFxDE;IACE,gBCnEE;EC6HN;EF3DE;IACE,mBCnEE;ECgIN;EF9DE;IACE,mBCnEE;ECmIN;EFjEE;IACE,gBCnEE;ECsIN;EFpEE;IACE,mBCnEE;ECyIN;EFvEE;IACE,mBCnEE;EC4IN;EF1EE;IACE,iBCnEE;EC+IN;AACF;AA/II;EACI,mBAAA;AAiJR;AA/II;EACI,UAAA;AAiJR;AA9II;EAEI,iBAAA;EACA,gBAAA;EAEA,mCAAA;EACA,iBAAA;AA8IR;AA3II;EACI,eAAA;EACA,mBAAA;AA6IR;AA1II;EACI,8CAAA;AA4IR;AA1II;EACI,kBAAA;AA4IR;AA1II;EACI,gBAAA;AA4IR;AA3IQ;EACI,mCAAA;AA6IZ;AA1II;EACI,6BAAA;EACA,oBAAA;EACA,gBAAA;AA4IR;AAzII;EACI,eAAA;AA2IR;AAtIY;EACI,UAAA;AAwIhB;AAnII;EACI,mBAAA;AAqIR;AAlII;EACI,6BAAA;EACA,eAAA;AAoIR;AAlIQ;EACI,kBAAA;AAoIZ;AAhII;EACI,mBAAA;AAkIR;AA/HI;EACI,uBAAA;AAiIR;AA/HQ;EACI,kCAAA;AAiIZ;AA7HI;EACI,mBAAA;AA+HR;AA5HI;EACI,kBAAA;AA8HR;AA3HY;EACI,cAAA;EACA,SAAA;EACA,QAAA;AA6HhB;AAxHI;EACI,mBAAA;AA0HR;AFnMI;EEtBJ;IAmGQ,cAAA;EA0HN;EAxHM;IACI,gBAAA;EA0HV;EAvHM;IACI,cAAA;IACA,kBAAA;IACA,WAAA;EAyHV;EAtHM;IACI,kBAAA;IACA,WAAA;EAwHV;EArHM;IACI,iBAAA;EAuHV;EArHU;IACI,mBAAA;EAuHd;EAnHM;IACI,oBAAA;IACA,aAAA;EAqHV;EAnHU;IACI,kBAAA;EAqHd;EAlHU;IACI,kBAAA;IACA,kBAAA;EAoHd;EA9Gc;IACI,4BAAA;EAgHlB;EA3GM;;IAEI,mBAAA;EA6GV;EA1GM;IACI,mBAAA;EA4GV;EA1GM;;IAEI,8BAAA;EA4GV;AACF","sourcesContent":["@import 'variables';\n\n@function color($color-name, $color-variant: null) {\n  // color variant is optional\n  @if ($color-variant != null) {\n    // map inception\n    @return map-get(map-get($colors, $color-name), $color-variant);\n  }@else {\n    @return map-get($colors, $color-name);\n  }\n}\n// buttons building section\n\n$btns: (\n  default: color(default, base),\n  primary: color(primary, base),\n  secondary:  color(secondary, base),\n  inverse: color(inverse, light),\n  success: color(success, base),\n  danger:  color(danger, base)\n);\n\n@mixin respond-to($breakpoint) {\n  @if $breakpoint == 'small' {\n    @media (max-width: 1024px) {\n      @content;\n    }\n  }@else if $breakpoint == 'large' {\n    @media (min-width: 1025px) {\n      @content;\n    }\n  }\n}\n\n@mixin vendor-prefix($name, $value) {\n  @each $vendor in ('-webkit-', '-moz-', '-ms-', '-o-', '') {\n    #{$name}: #{$value};\n  }\n}\n\n\n@mixin placeholder() {\n  color: color(inverse, light) !important;\n  font-family: 'Omnes-ATT-W02-Italic'!important;\n  font-style: normal;\n  opacity: 1;\n  font-size: 16px;\n}\n\n// dynamic\n@include respond-to(small) {\n  @each $gridname, $gridvalue in $grids {\n    .col-sm-#{$gridname} {\n      width: $gridvalue;\n    }\n  }\n  @each $gridname, $gridvalue in $grids {\n    .col-sm-offset-#{$gridname} {\n      margin-left: $gridvalue;\n    }\n  }\n}\n@include respond-to (large) {\n  @each $gridname, $gridvalue in $grids {\n    .col-md-#{$gridname} {\n      width: $gridvalue;\n    }\n  }\n  @each $gridname, $gridvalue in $grids {\n    .col-md-offset-#{$gridname} {\n      margin-left: $gridvalue;\n    }\n  }\n}\n","// Global Variables\n@import './../../../../../assets/style/var-config';\n// grids here\n$grids: (\n  1: 8.33%,\n  2: 16.66%,\n  3: 25%,\n  4: 33.33%,\n  5: 41.66%,\n  6: 50%,\n  7: 58.33%,\n  8: 66.66%,\n  9: 75%,\n  10: 83.33%,\n  11: 91.66%,\n  12: 100%\n);\n\n\n// refer http://digitaldesign.web.att.com/getstarted-color.html\n$att-dark-blue: hsl(205, 94%, 35%); // #0568ae\n$f-red: hsl(0, 66%, 49%); // #cf2a2a Functional Red\n$fb-gray: hsl(0, 0%, 95%); // #f2f2f2 Functional background Gray\n$att-dark-gray: hsl(0, 0%, 35%); // #5a5a5a\n$f-green: hsl(150, 100%, 24%); // #007a3e functional Green\n// $att-orange: hsl(30, 100%, 46%); // #ea7400 ATT Orange\n$att-orange: #ea7400; //ATT Orange\n\n// set color map easy use variables\n$primary: $att-orange !default;\n$secondary: $att-dark-blue !default;\n$default: $fb-gray !default;\n$inverse: $att-dark-gray !default;\n$danger: $f-red !default;\n$success: $f-green !default;\n\n\n// color variable map\n$colors: (\n  info: #009fdb,\n  enrolledActive:  #66cc00,\n  enrolledNotActive: #70c5e9,\n  notEnrolled: #fdb91d,\n  outOfCompliance: #cccccc,\n  appleNotinstalled: #fcbb15, \n\n  // Primary - Blue color\n  primary: (\n    base: $primary,\n    light: lighten($primary, 15%),\n    lightest: lighten($primary, 60%),\n    dark: darken($primary, 15%)\n  ),\n\n  // Secondary - Orange color\n  secondary: (\n    base: $secondary,\n    light: lighten($secondary, 15%),\n    lightest: lighten($secondary, 60%),\n    dark: darken($secondary, 15%)\n  ),\n\n  // default - Gray color\n  default: (\n    base: $default,\n    light: lighten($default, 5%), // #fff white\n    dark: darken($default, 12.8%), // #d2d2d2 ATT Light Gray\n    darker: darken($default, 18%) // #c4c4c4\n  ),\n\n  // Inverse - Black color\n  inverse: (\n    base: $inverse,\n    light: lighten($inverse, 11.25%), // #767676 Auxiliary Gray\n    lightest: lighten($inverse, 25%), // #999999\n    lighter: lighten($inverse, 23.4%), // #959595 ATT Gray\n    dark: darken($inverse, 15%), // #333 ATT Dark Gray (2015)\n    darker: darken($inverse, 25.2%), // #191919 Functional Digital Text Black\n    darkest: darken($inverse, 35%) // #000 \n  ),\n\n  // danger - Red color\n  danger: (\n    base: $danger,\n    light: lighten($danger, 15%),\n    dark: darken($danger, 15%)\n  ),\n\n  // success - Green color\n  success: (\n    base: $success,\n    light: lighten($success, 15%),\n    dark: darken($success, 15%)\n  )\n);\n","@import \"../../../../../lib/ng2-sapmp/src/assets/style/mixinfunction\";\n\n.reports-tab {\n    // margin: 0 23%;\n    .margin-10 {\n        margin-bottom: 20px;\n    }\n    .dropdown-section, .select-dates {\n        width: 60%;\n    }\n\n    label {\n        // font-family: \"Times New Roman\", Times, serif;\n        margin-right: 3px;\n        margin-top: -2px;\n        // font-size: 100%;\n        font-family : 'Omnes-ATT-W02', Arial;\n        font-size: 1.6rem;\n    }\n\n    p {\n        font-size: 100%;\n        margin-bottom: 20px;\n    }\n\n    .dateRangeHeader {\n        font : 1.6rem 'Omnes-ATT-W02-medium' !important;\n    }\n    .dateRangeLabel {\n        margin-bottom: 5px;\n    }\n    .device-header{\n        margin-top: 20px;\n        label {\n            font : 1.4rem 'Omnes-ATT-W02-medium';\n        }\n    }\n    .cta {\n        border-top: 1px solid color(default, dark);\n        padding: 30px 0 60px;\n        margin-top: 30px;\n    }\n\n    .box-outer {\n        padding: 0 30px;\n    }\n\n    tr {\n        th {\n            &:first-child {\n                width: 15%;\n            }\n        }\n    }\n\n    .reports {\n        margin-bottom: 20px;\n    }\n\n    .buttons-section {\n        border-top: 1px solid color(default, dark);\n        padding: 30px 0;\n\n        .btn-cancel {\n            margin-right: 30px;\n        }\n    }\n\n    .check {\n        margin-bottom: 30px;\n    }\n\n    .error-text {\n        color: color(danger, base);\n\n        .skin {\n            border: 1px solid color(danger, base);\n        }\n    }\n\n    .modal-header {\n        margin-bottom: 10px;\n    }\n\n    .reporttabcontainer {\n        position: relative;\n\n        .pagination {\n            &::after {\n                border: 0 none;\n                height: 0;\n                width: 0;\n            }\n        }\n    }\n\n    .alert {\n        margin-bottom: 30px;\n    }\n\n    @include respond-to(small) {\n        margin: 0 15px;\n\n        .margin-10 {\n            margin: 10px 0px;\n        }\n\n        .btn-cancel {\n            margin: 20px 0;\n            text-align: center;\n            width: 100%;\n        }\n\n        .btn {\n            text-align: center;\n            width: 100%;\n        }\n\n        .buttons-section {\n            padding: 20px 0 0;\n\n            .btn-cancel {\n                margin: 20px 0 30px;\n            }\n        }\n\n        .cta {\n            padding: 20px 0 30px;\n            margin: 0 1px;\n\n            a {\n                text-align: center;\n            }\n\n            button {\n                margin: 0 0 0 20px;\n                text-align: center;\n            }\n        }\n\n        .tab-nav {\n            app-tab {\n                .list > a {\n                    padding: 25px 1px !important;\n                }\n            }\n        }\n\n        .reports,\n        .check {\n            margin-bottom: 20px;\n        }\n\n        .form-group {\n            margin-bottom: 20px;\n        }\n        .step-indicator,\n        .alert {\n            margin-bottom: 30px !important;\n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
